import {HeaderLanguageType} from "@next/utils"
import {LANGUAGE_ENGLISH} from "../../config/constants"

export const joinArrayBasedOnLanguage = (siteLanguage: HeaderLanguageType, array: any[]) => {
    return siteLanguage === LANGUAGE_ENGLISH ? array.join(" ") : array.join(", ")
}
